import React from 'react';
import proptypes from 'prop-types';
import { Tile, TileMedia, TileText, TileContent } from '@one-thd/sui-atomic-components';
import { Tooltip } from '../tooltip/tooltip';
import { AvailabilityTooltipContent } from '../tooltip/availability-tooltip-content';

const { bool, string, func, shape } = proptypes;

export const SwatchComponent = ({
  value,
  isSelected,
  isAvailable,
  miniSwatch,
  swatchGuid,
  displayInToolTip,
  title,
  impressionProps,
  onSwatchClick,
  hoveredCombinationDetails,
  onSwatchMouseEnter,
  onSwatchMouseLeave,
  anchorRef,
  onPopoverClose,
  showMainTooltip,
  showUnavailableTooltip,
  shouldShowOOSTTooltip,
  isOOS,
  isUnavailable,
  unavailableTooltipMessage,
  oosTooltipMessage
}) => {

  const unavailable = (!isAvailable || isOOS || isUnavailable) && !miniSwatch;

  const swatchChild = (
    <div
      onMouseEnter={onSwatchMouseEnter}
      onMouseLeave={onSwatchMouseLeave}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...impressionProps}
    >
      <Tile
        value={value}
        aria-label={value}
        selected={isSelected}
        unavailable={unavailable}
        onClick={onSwatchClick}
      >
        <TileContent>
          <TileMedia
            alt={value}
            height="7"
            src={swatchGuid}
            loading="lazy"
            disableDiagonal={isOOS}
          />
          {displayInToolTip && <TileText>{title}</TileText>}
        </TileContent>
      </Tile>
    </div>
  );

  const shouldShowPopover = (showMainTooltip || showUnavailableTooltip || shouldShowOOSTTooltip) && anchorRef?.current;

  return (
    <>
      {swatchChild}
      {shouldShowPopover && (
        <Tooltip
          open={anchorRef?.current}
          anchorEl={anchorRef?.current}
          onClose={onPopoverClose}
          placement={showMainTooltip ? 'top' : 'bottom'}
        >
          <AvailabilityTooltipContent
            showMainTooltip={showMainTooltip}
            showUnavailableTooltip={showUnavailableTooltip}
            hoveredCombinationDetails={hoveredCombinationDetails}
            shouldShowOOSTTooltip={shouldShowOOSTTooltip}
            unavailableTooltipMessage={unavailableTooltipMessage}
            oosTooltipMessage={oosTooltipMessage}
          />
        </Tooltip>
      )}
    </>
  );
};

SwatchComponent.propTypes = {
  value: string.isRequired,
  isSelected: bool.isRequired,
  isAvailable: bool.isRequired,
  miniSwatch: bool,
  swatchGuid: string.isRequired,
  displayInToolTip: bool,
  title: string,
  onSwatchClick: func.isRequired,
  onSwatchMouseEnter: func.isRequired,
  onSwatchMouseLeave: func.isRequired,
  impressionProps: shape({}),
  showMainTooltip: bool,
  showUnavailableTooltip: bool,
  anchorRef: shape({}),
  hoveredCombinationDetails: shape({}),
  onPopoverClose: func.isRequired,
  shouldShowOOSTTooltip: bool,
  isOOS: bool,
  isUnavailable: bool,
  unavailableTooltipMessage: string,
  oosTooltipMessage: string,
};

SwatchComponent.defaultProps = {
  miniSwatch: false,
  displayInToolTip: false,
  title: '',
  impressionProps: {},
  showMainTooltip: false,
  showUnavailableTooltip: false,
  anchorRef: null,
  hoveredCombinationDetails: {},
  shouldShowOOSTTooltip: false,
  isOOS: false,
  isUnavailable: false,
  unavailableTooltipMessage: '',
  oosTooltipMessage: '',
};